import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, KeyRound, LogOut } from "lucide-react";
import ChangePassword from "@/components/ChangePassword";
import { useAuth } from "@/contexts/AuthContext";
import useInstallPrompt from "@/hooks/useInstallPrompt";
import { PLANT_NAME } from "@/mobile/ui";

export default function MobileAccount({ user }) {
  const { logout } = useAuth();
  const nav = useNavigate();
  const { canInstall, install } = useInstallPrompt();
  const [pwOpen, setPwOpen] = useState(false);
  const initials = (user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  const rows = [
    ["Name", user?.name], ["Email", user?.email], ["Role", (user?.role || "").replace(/_/g, " ")], ["Plant", PLANT_NAME],
  ];
  return (
    <div className="p-3 pb-6 space-y-3" data-testid="mobile-account">
      <div className="flex items-center gap-3 rounded-lg p-4 bg-[var(--m-card)] border border-[var(--m-border)]">
        <span className="w-12 h-12 rounded-full flex items-center justify-center text-[15px] font-bold text-[#0f1111]" style={{ background: "var(--m-accent)" }}>{initials}</span>
        <div className="min-w-0">
          <div className="text-[17px] font-bold truncate">{user?.name}</div>
          <div className="text-[13px] text-[var(--m-muted)] truncate">{user?.email}</div>
        </div>
      </div>
      <dl className="rounded-lg bg-[var(--m-card)] border border-[var(--m-border)] divide-y divide-[var(--m-border)]">
        {rows.map(([k, v]) => (
          <div key={k} className="flex items-center justify-between gap-3 px-4 min-h-[48px]">
            <dt className="text-[14px] text-[var(--m-muted)]">{k}</dt>
            <dd className="text-[14px] font-medium text-right truncate">{v || "—"}</dd>
          </div>
        ))}
      </dl>
      <div className="flex flex-col gap-2.5">
        {canInstall && (
          <button type="button" onClick={install} className="m-btn-primary h-12 font-semibold text-[15px] flex items-center justify-center gap-2">
            <Download className="w-4 h-4" /> Install app
          </button>
        )}
        <button type="button" onClick={() => setPwOpen(true)}
          className="h-12 rounded-full border border-[var(--m-border)] bg-[var(--m-card)] font-semibold text-[15px] flex items-center justify-center gap-2" data-testid="mobile-account-change-password">
          <KeyRound className="w-4 h-4" /> Change password
        </button>
        <button type="button" onClick={async () => { await logout(); nav("/login"); }}
          className="h-12 rounded-full border border-[var(--m-border)] bg-[var(--m-card)] font-semibold text-[15px] flex items-center justify-center gap-2" data-testid="mobile-logout-btn">
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </div>
      <ChangePassword open={pwOpen} onOpenChange={setPwOpen} />
    </div>
  );
}
